import { useEffect, useState } from 'react'

const still = (value: number) => value === 0 || (typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches)

/** A number that counts up when it first appears. Screen readers get the final value straight away. */
export default function CountUp({ value }: { value: number }) {
  const [shown, setShown] = useState(0)
  const skip = still(value)
  useEffect(() => {
    if (skip) return
    let frame = 0
    const start = performance.now()
    const tick = (t: number) => {
      const p = Math.min(1, (t - start) / 800)
      setShown(Math.round(value * (1 - Math.pow(1 - p, 3))))
      if (p < 1) frame = requestAnimationFrame(tick)
    }
    frame = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(frame)
  }, [value, skip])
  return <><span aria-hidden="true">{skip ? value : shown}</span><span className="sr-only">{value}</span></>
}
